import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IntroductionComponent } from './introduction/introduction.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { CurrentComponent } from './current/current.component';
import { EnhancedComponent } from './enhanced/enhanced.component';
import { ComparisonComponent } from './comparison/comparison.component';
import { ScoreComponent} from './score/score.component';

const routes: Routes = [
  /* Direct upon app startup */
  {
    path: '',
    redirectTo: '/introduction',
    pathMatch: 'full'
  },
  /* Introduction Related */
  {
    path: 'introduction',
    component: IntroductionComponent
  },
  /* Questionnaire Related */
  {
    path: 'questionnaire',
    component: QuestionnaireComponent
  },
  /* Current Allocation Related */
  {
    path: 'current-allocation',
    component: CurrentComponent
  },
  /* Enhanced Allocation Related */
  {
    path: 'enhanced-allocation',
    component: EnhancedComponent
  },
  /* Allocation Comparison Related */
  {
    path: 'allocation-comparison',
    component: ComparisonComponent
  },
  /* Score Related */
  {
    path: 'score',
    component: ScoreComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
